

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Mun {
}

export default Mun
